import React from "react";
import useCountdown from "../hooks/useCountdown";
import analytics from "../Services/analyticsService";
import { LIMIT_COPY, formatCountdown } from "../utils/hostingCopy";

// Shown when the host has used their 3 free games in the last 6 hours.
const HostingLimitModal = ({
  coinBalance,
  cost,
  nextAvailableAt,
  serverNow,
  busy,
  error,
  onHostNow,
  onGetCoins,
  onClose,
}) => {
  const left = useCountdown(nextAvailableAt, serverNow, () => {
    analytics.track("room_limit_reset", {});
    onClose();
  });
  const canAfford = coinBalance >= cost;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-labelledby="hosting-limit-title">
      <div className="bg-white rounded-2xl shadow-xl max-w-sm w-full p-6 text-center">
        <h3 id="hosting-limit-title" className="text-xl font-bold text-gray-900 mb-2">{LIMIT_COPY.title}</h3>
        <p className="text-gray-600 text-sm mb-4">{LIMIT_COPY.body}</p>
        <div className="rounded-xl bg-red-50 px-4 py-3 mb-4">
          <p className="text-3xl font-extrabold text-red-700 tabular-nums" aria-live="off">{formatCountdown(left)}</p>
          <p className="text-xs font-semibold uppercase tracking-wide text-red-400 mt-1">{LIMIT_COPY.countdownLabel}</p>
        </div>
        {error && <p role="alert" className="text-sm text-red-700 mb-3">{error}</p>}
        <div className="flex flex-col gap-2">
          {canAfford && (
            <button
              type="button"
              onClick={onHostNow}
              disabled={busy}
              className="w-full px-4 py-3 bg-red-600 hover:bg-red-700 disabled:opacity-60 text-white rounded-xl text-sm font-semibold transition"
            >
              {busy ? LIMIT_COPY.hostNowLoading : LIMIT_COPY.hostNow(cost)}
            </button>
          )}
          <button
            type="button"
            onClick={onGetCoins}
            disabled={busy}
            className={`w-full px-4 py-3 rounded-xl text-sm font-semibold transition disabled:opacity-60 ${
              canAfford ? "border border-gray-300 text-gray-800 hover:bg-gray-50" : "bg-red-600 hover:bg-red-700 text-white"
            }`}
          >
            {LIMIT_COPY.getCoins}
          </button>
          <button
            type="button"
            onClick={onClose}
            disabled={busy}
            className="w-full px-4 py-2 text-sm font-medium text-gray-600 hover:text-gray-800"
          >
            {LIMIT_COPY.later}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HostingLimitModal;
